import { Users, Briefcase } from 'lucide-react';

export const navigationLinks = [
  { to: '/jobs', icon: Briefcase, text: 'Find Ranch Jobs' },
  { to: '/job-seekers', icon: Users, text: 'Job Seekers' },
];
